import type {Image, LineDiscountItem, LineItemError, ManualDiscountInput, Pricing, Promotion, Unit, UnitQuantity, VariantIdentifier, VariantLineItem} from "@/shared/graphql/types";

/**
 * Represents a lineItem on the client side, not to the api side of the app.
 * ClientBasketItem is stored in indexDB for offline en persistent storage
 */
export class ClientLineItem {

    readonly id: string //Unique line id used by indexDB and the server
    readonly identifier: VariantIdentifier
    readonly type: ClientLineItemType
    readonly variantType: ProductVariantType
    readonly name?: string
    readonly code: string
    readonly unit?: Unit
    readonly image?: Image
    readonly stepSize: number

    readonly totalPrice?: Pricing
    readonly unitPrice?: Pricing
    comparePrice?: Pricing

    readonly errors?: Array<LineItemError>
    readonly discountItems:Array<LineDiscountItem>

    parentLineItem: string
    promotion: Promotion

    updating: boolean

    includedItems : Array<VariantLineItem>
    extraItems : Array<VariantLineItem>

    private _quantity: number
    private _unitQuantity: UnitQuantity
    remark: string
    discount: ManualDiscountInput

    constructor(id: string,
                identifier: VariantIdentifier,
                type: ClientLineItemType,
                variantType: ProductVariantType,
                code: string,
                name: string,
                unit: Unit,
                quantity: number,
                unitQuantity: UnitQuantity,
                stepSize: number,
                remark: string,
                image?: Image,
                unitPrice?: Pricing,
                totalPrice?: Pricing,
                error?: Array<LineItemError>,
                discount?: ManualDiscountInput,
                discountItems?: Array<LineDiscountItem>,
    ) {
        this.id = id
        this.identifier = identifier
        this.variantType = variantType
        this.type = type
        this.code = code
        this.name = name
        this._quantity = quantity
        this.remark = remark
        this.unit = unit
        this.image = image
        this.unitPrice = unitPrice
        this.totalPrice = totalPrice
        this.errors = error
        this.updating = (unitPrice == undefined)
        this.discount = discount
        this.discountItems = discountItems
        this.stepSize = stepSize ?? 1
        this._unitQuantity =unitQuantity
    }

    get identity() {
        return clientLineItemIdentity(this.identifier, this.unit.id)
    }

    set quantity(qt: number) {
        this._quantity = qt
        this.updating = true
    }

    get quantity() {
        return this._quantity
    }

    get unitQuantity() {
        return this._unitQuantity
    }

    hasError(code: string): boolean {
        return this.errors.some((item: LineItemError) => item.code == code)
    }

    getError(code: string): LineItemError {
        return this.errors.find((item: LineItemError) => item.code == code)
    }

}

export const clientLineItemIdentity = (identifier: VariantIdentifier, unit?: string) => unit ? `${identifier.kind}:${identifier.value}-${unit}` : `${identifier.kind}:${identifier.value}`;

export enum ClientLineItemType {
    Cost = 'COST',
    Promotion = 'PROMOTION',
    Variant = 'VARIANT',
    Invalid = 'INVALID',
}

export enum ProductVariantType {
    Contribution = 'CONTRIBUTION',
    Gift = 'GIFT',
    Labor = 'LABOR',
    Loan = 'LOAN',
    Product = 'PRODUCT',
    Reduction = 'REDUCTION',
    Resource = 'RESOURCE'
}
